class Lista{
    constructor(id, descripcion, porcentaje){
        this.id = id;
        this.descripcion = descripcion;
        this.porcentaje = porcentaje;
    }
}
export default Lista;